import React, {useEffect,useState} from 'react'
import "../styles/LoginForm.css"
import {Link} from "react-router-dom";

// import TextField from '@material-ui/core/TextField'
import { Button, TextField } from '@material-ui/core'
import { Field, Form, Formik } from 'formik'
import { userActions } from '../actions/user.actions'
import {useSelector,useDispatch} from 'react-redux'
import {useHistory} from 'react-router-dom'

function LoginForm() {
    const [passwordShown,setpasswordShown]=useState(false)
    const LoginReducer = useSelector(state => state.LoginReducer);
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        if (LoginReducer.loggedIn)
            history.push('/admin/dashboard');
        else if(LoginReducer.error){
            alert("Incorrect username or password");
        }
    }, [LoginReducer, history])

    const iniVal = {
        userid: '',
        pass: ''
    }
    const handlePass=()=>{
        setpasswordShown(true)
    }
    const handleshow=()=>{
        setpasswordShown(false)
    }
    const handleLogin = (values) => {
        console.log(values);
        dispatch(userActions.login(values.userid, values.pass,"admin"));
    }
    return (
        <div className="loginMain">
            <div className="loginContainer">
                <h3>NMO Admin Portal</h3>
                <h4>Enter credentials to login</h4>
                <Formik initialValues={iniVal} onSubmit={handleLogin}>
                    {
                        () => (
                            <Form>
                                  <div style={{display:'flex', flexDirection:'column', gap:'20px'}}>
                                    <Field name="userid" as={TextField}  label="UserId / Email" variant="outlined" />
                                    <Field name="pass" as={TextField}  label="Password" variant="outlined" type={passwordShown ? "text" : "password"} />
                                    {/* <div style={{position:'fixed',left:'795px',top:'316px'}}>{passwordShown?  <i class="fa fa-eye  openbtn"  onClick={handleshow}></i>: <i class="fa fa-eye-slash  openbtn"  onClick={handlePass}></i>}</div>  */}
                                    <Button variant="contained" color="primary" type="submit">Login</Button>
                                    <Link className="link" to={"/Forgot_password"}><Button variant="contained" color="primary">Forgot Password ?</Button></Link>
                                </div>
                            </Form>
                        )
                    }
                </Formik>
            </div>
        </div>
    )
}

export default LoginForm
